/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import translateMixin from '../mixins/translate-mixin.js';

window.stripe = Stripe(window.stripe_public_key);

const __vue_script__ = {
  mixins: [translateMixin],
  props: ["errors", "disabled", "currency"],
  data() {    
    return {
      showingHelp: false,
      stripeCard: null,
    }
  },
  methods: {
    toggleHelp() {
      this.showingHelp = !this.showingHelp;
    },
    hideHelp() {
      this.showingHelp = false;
    },
    tokenize(successCallback, errorCallback) {
      stripe.createToken(this.stripeCard).then((result) => {
        if (result.error) {
          // Exiba os erros no formulário
          errorCallback(result.error.message)
        } else {
          // Envie o token para o seu servidor
          successCallback(result.token);
        }
      });
    }
  },
  mounted() {
      // Estilo dos elementos do formulário
    var style = {
      base: {
        color: '#495057',
        fontFamily: '"NotoSans", "Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': { color: 'rgba(33, 38, 49, 0.3)' }
      },
      invalid: {
        color: '#dc3545',
        iconColor: '#dc3545'
      }
    };

    // Crie instâncias dos elementos de cartão
    var elements = stripe.elements();
    this.stripeCard = elements.create('cardNumber', { style: style });
    var cardExpiry = elements.create('cardExpiry', { style: style });
    var cardCvc = elements.create('cardCvc', { style: style });

    this.stripeCard.mount('#card-element');
    cardExpiry.mount('#card-expiry-element');
    cardCvc.mount('#card-cvc-element');

    // Manipule mudanças de validação do cartão
    this.stripeCard.addEventListener('change', (event) => {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { staticClass: "form-stripe" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-6" },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "card-cvc-element" } }, [
              _vm._v("\n          CVV\n          "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.hideHelp,
                      expression: "hideHelp",
                    },
                  ],
                  staticClass: "help-button",
                  attrs: { type: "button" },
                  on: { click: _vm.toggleHelp },
                },
                [_c("i", { staticClass: "icon-help" })]
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "form-control",
              attrs: { id: "card-cvc-element" },
            }),
          ]),
          _vm._v(" "),
          _vm.showingHelp
            ? _c("cvv-help", { attrs: { left: true } })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "card-element" } }, [_vm._v("Card Number")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-control", attrs: { id: "card-element" } }),
      _vm._v(" "),
      _c("div", {
        staticClass: "mt-2 text-danger",
        attrs: { id: "card-errors", role: "alert" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-6" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "card-expiry-element" } }, [
          _vm._v("Valid Thru"),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "form-control",
          attrs: { id: "card-expiry-element" },
        }),
      ]),
    ])
  },
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-60ad0a58_0", { source: ".form-stripe .form-control {\n  display: flex;\n  align-items: center;\n}\n.form-stripe .form-control > div {\n  flex: 1 1 100%;\n  width: 100%;\n}\n\n/*# sourceMappingURL=form-stripe.vue.map */", map: {"version":3,"sources":["frontend/components/form-stripe.vue","form-stripe.vue"],"names":[],"mappings":"AA0GA;EACA,aAAA;EACA,mBAAA;ACzGA;AD2GA;EACA,cAAA;EACA,WAAA;ACzGA;;AAEA,0CAA0C","file":"form-stripe.vue","sourcesContent":["<template>\n  <form class=\"form-stripe\">\n    <div class=\"form-group\">\n      <label for=\"card-element\">Card Number</label>\n      <div id=\"card-element\" class=\"form-control\"></div>\n      <div id=\"card-errors\" role=\"alert\" class=\"mt-2 text-danger\"></div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-lg-6\">\n        <div class=\"form-group\">\n          <label for=\"card-expiry-element\">Valid Thru</label>\n          <div id=\"card-expiry-element\" class=\"form-control\"></div>\n        </div>\n      </div>\n\n      <div class=\"col-lg-6\">\n        <div class=\"form-group\">\n          <label for=\"card-cvc-element\">\n            CVV\n            <button class=\"help-button\" type=\"button\" @click=\"toggleHelp\" v-click-outside=\"hideHelp\">\n              <i class=\"icon-help\"></i>\n            </button>\n          </label>\n          <div id=\"card-cvc-element\" class=\"form-control\"></div>\n        </div>\n        <cvv-help v-if=\"showingHelp\" :left=\"true\" />\n      </div>\n    </div>\n  </form>\n</template>\n\n<script>\nimport translateMixin from '../mixins/translate-mixin.js';\n\nwindow.stripe = Stripe(window.stripe_public_key);\n\nexport default {\n  mixins: [translateMixin],\n  props: [\"errors\", \"disabled\", \"currency\"],\n  data() {    \n    return {\n      showingHelp: false,\n      stripeCard: null,\n    }\n  },\n  methods: {\n    toggleHelp() {\n      this.showingHelp = !this.showingHelp;\n    },\n    hideHelp() {\n      this.showingHelp = false;\n    },\n    tokenize(successCallback, errorCallback) {\n      stripe.createToken(this.stripeCard).then((result) => {\n        if (result.error) {\n          // Exiba os erros no formulário\n          errorCallback(result.error.message)\n        } else {\n          // Envie o token para o seu servidor\n          successCallback(result.token);\n        }\n      });\n    }\n  },\n  mounted() {\n      // Estilo dos elementos do formulário\n    var style = {\n      base: {\n        color: '#495057',\n        fontFamily: '\"NotoSans\", \"Helvetica Neue\", Helvetica, sans-serif',\n        fontSmoothing: 'antialiased',\n        fontSize: '16px',\n        '::placeholder': { color: 'rgba(33, 38, 49, 0.3)' }\n      },\n      invalid: {\n        color: '#dc3545',\n        iconColor: '#dc3545'\n      }\n    };\n\n    // Crie instâncias dos elementos de cartão\n    var elements = stripe.elements();\n    this.stripeCard = elements.create('cardNumber', { style: style });\n    var cardExpiry = elements.create('cardExpiry', { style: style });\n    var cardCvc = elements.create('cardCvc', { style: style });\n\n    this.stripeCard.mount('#card-element');\n    cardExpiry.mount('#card-expiry-element');\n    cardCvc.mount('#card-cvc-element');\n\n    // Manipule mudanças de validação do cartão\n    this.stripeCard.addEventListener('change', (event) => {\n      var displayError = document.getElementById('card-errors');\n      if (event.error) {\n        displayError.textContent = event.error.message;\n      } else {\n        displayError.textContent = '';\n      }\n    });\n  }\n}\n</script>\n\n<style lang=\"scss\">\n.form-stripe {\n  .form-control {\n    display: flex;\n    align-items: center;\n\n    > div {\n      flex: 1 1 100%;\n      width: 100%;\n    }\n  }\n}\n</style>",".form-stripe .form-control {\n  display: flex;\n  align-items: center;\n}\n.form-stripe .form-control > div {\n  flex: 1 1 100%;\n  width: 100%;\n}\n\n/*# sourceMappingURL=form-stripe.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/form-stripe.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__